
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import ManagersMultiselect from "@/components/autocompleteMultiselects/ManagersMultiselectNew.vue";
import EmploymentTypeSelect from "@/components/autocompleteMultiselects/EmploymentTypeSelect.vue";
import FormTextarea from "@/components/form/FormTextarea.vue";
import FormToggle from "@/components/form/FormToggle.vue";
import SkillsMultiselect from "@/components/autocompleteMultiselects/SkillsMultiselectNew.vue";
import IndustriesMultiselect from "@/components/autocompleteMultiselects/IndustriesMultiselectNew.vue";
import FormDatepicker from "@/components/form/FormDatepicker.vue";
import FormGroup from "@/components/form/FormGroupNew.vue";
import UIButton from "@/components/button/ui-button.vue";
import FormInput from "@/components/form/FormInputNew.vue";
import CheckboxButtonGroupV2 from "@/components/common/CheckboxButtonGroupV2.vue";
import RadioButtonGroupV2 from "@/components/common/RadioButtonGroupV2.vue";
import RadioButtonGroup from "@/components/common/RadioButtonGroup.vue";
import ModalFullScreen from "@/components/modal/ModalFullScreenNew.vue";
import ModalHeader from "@/components/modal/ModalHeader.vue";
import ProfileCountrySelect from "@/components/autocompleteMultiselects/ProfileCountrySelectNew.vue";
import InputRangeFilter from "@/components/filters/InputRangeFilter.vue";
import FormInputGroup from "@/components/form/FormInputGroupNew.vue";
import Tooltip from "@/components/common/Tooltip.vue";
import TooltipVariants from "@/entities/TooltipVariants";
import CREATE_POSTING from "@/apollo/jobboard/CreatePosting.gql";
import CREATE_POSTING_SKILLS from "@/apollo/skills/CreatePostingSkills.gql";
import CREATE_POSTING_Tags from "@/apollo/tag/CreatePostingTags.gql";
import CREATE_POSTING_INDUSTRIES from "@/apollo/industries/CreatePostingIndustries.gql";
import UPDATE_POSTING from "@/apollo/jobboard/UpdatePosting.gql";

import DropdownOption from "@/entities/DropdownOption";
import { NOTIFICATION } from "@/entities/Events";
import Message from "@/data/notificationsMessages";
import RouteNames from "@/entities/RouteNames";
import RadioOption from "@/entities/RadioOption";
import EmploymentType from "@/entities/EmploymentType";
import PostingPublicValues from "@/entities/PostingPublicValues";
import DurationType from "@/entities/DurationType";
import ModalSectionsDivider from "@/components/modal/ModalSectionsDivider.vue";
import ProfileCountries from "@/entities/locationEntities/ProfileCountries";
import getStateProvinceSelectTitle from "@/helpers/locations/getStateProvinceSelectTitle";

import capitalizeLabel from "@/helpers/cardInfoHelperFunctions/capitalizeLabel";
import RegionInput from "@/components/autocompleteMultiselects/RegionInputNew.vue";
import ModalContent from "@/components/modal/ModalContent.vue";
import CalenderIcon from '@/components/icons/CalendarIconV2.vue'
import CustomTagsMultiselect from "../autocompleteMultiselects/customOptions/CustomTagsMultiselect.vue";
import InfoIcon from '@/components/icons/InfoIcon.vue'
import SwitchComponent from "@/components/Switch/Switch.vue";

interface PostingFormData {
  id?: string;
  company_id: string;
  job_title?: string;
  country?: DropdownOption[];
  state?: DropdownOption[];
  city?: string;
  active: boolean;
  public: string;
  duration: number;
  durationUnit: string;
  managersIds: string[];
  industries: DropdownOption[];
  skillsIds: number[];
  description: string | null;
  employment_type: DropdownOption[];
  duration_type: string;
  start_date: string | Date | null;
  end_date: string | Date | null;
  tagsIds: string[]
  min_rate: number | null;
  max_rate: number | null

}

interface PostingDTO {
  active: boolean;
  public: boolean;
  company_id: string;
  description: string | null;
  job_title: string;
  employment_type: string;
  duration: number | null;
  manager_id: string | null;
  duration_type: string;
  start_date: string | Date | null;
  end_date: string | Date | null;
  country: string | null;
  state: string | null;
  city: string | null;
  max_rate: number | null
  min_rate: number | null
}

interface PostingSkillData {
  posting_id: string;
  skill_id: number;
}
interface PostingTagData {
  posting_id: string;
  tag_id: string;
}

interface PostingIndustry {
  posting_id: string;
  industry_id: string;
}

interface PostingSkill {
  id: string,
  skill: {
    id: number,
    name: string,
  }
}
interface PostingTag {
  id: string,
  tag: {
    id: string,
    name: string,
  }
}

enum DurationUnit {
  DAYS = "days",
  WEEKS = "weeks",
}

@Component({
  components: {
    ModalContent,
    RegionInput,
    ManagersMultiselect,
    SkillsMultiselect,
    EmploymentTypeSelect,
    IndustriesMultiselect,
    FormTextarea,
    FormGroup,
    RadioButtonGroup,
    CheckboxButtonGroupV2,
    FormToggle,
    FormDatepicker,
    FormInput,
    ModalFullScreen,
    Tooltip,
    TooltipVariants,
    SwitchComponent,
    UIButton,
    ModalHeader,
    ModalSectionsDivider,
    ProfileCountrySelect,
    RadioButtonGroupV2,
    CalenderIcon,
    CustomTagsMultiselect,
    InputRangeFilter,
    FormInputGroup,
    InfoIcon
  },
  model: {
    prop: "showDialog",
    event: "toggle",
  },
})
export default class PostingModal extends Vue {
  @Prop({ type: Object, default: undefined }) readonly data?: any;
  @Prop({ type: Boolean, default: false }) readonly showDialog!: boolean;
  @Prop({ type: String, required: true }) readonly companyId!: string;
  @Prop({ type: String, default: undefined }) readonly managerId?: string;
  valid: boolean = false;
  countryFromDB = "";
  TooltipVariants = TooltipVariants;
  posting: PostingFormData = {
    id: undefined,
    duration: 1,
    durationUnit: DurationUnit.DAYS,
    company_id: this.companyId,
    job_title: undefined,
    country: [],
    state: [],
    city: "",
    active: true,
    public: PostingPublicValues.INTERNAL,
    managersIds: [],
    industries: [],
    skillsIds: [],
    description: null,

    employment_type: [{ id: "1", name: EmploymentType.CONTRACTOR }],
    duration_type: DurationType.INTERVAL,
    start_date: null,
    end_date: null,
    min_rate: null,
    max_rate: null,
    tagsIds: []

  };

  durationUnitOptions: RadioOption[] = [
    { value: DurationUnit.WEEKS, label: capitalizeLabel(DurationUnit.WEEKS) },
    { value: DurationUnit.DAYS, label: capitalizeLabel(DurationUnit.DAYS) },
  ];

  durationTypeOptions: RadioOption[] = [
    { value: DurationType.INTERVAL, label: capitalizeLabel("Date range") },
    { value: DurationType.DURATION, label: capitalizeLabel(DurationType.DURATION) },
  ];

  publicTypeOptions: RadioOption[] = [
    { value: PostingPublicValues.MARKETPLACE, label: capitalizeLabel(PostingPublicValues.MARKETPLACE, " + ") },
    { value: PostingPublicValues.INTERNAL, label: capitalizeLabel(PostingPublicValues.INTERNAL + ' Posting') },
  ];


  toggleActive(isOn) {
    this.posting.active = isOn
  }
  mounted() {
    if (this.data) {

      const {
        skills: incomingSkills,
        manager: incomingManager,
        employment_type: incomingEmploymentType,
        industries: incomingIndustries,
        duration: incomingDuration,
        public: incomingPublic,
        country: incomingCountry,
        state: incomingState,
        posting_tags: incomingtags,
        min_rate,
        max_rate

      } = this.data;

      this.countryFromDB = incomingCountry;

      const skillsIds = incomingSkills.map((incomingSkill: PostingSkill) => incomingSkill.skill.id)
      const tagIds = incomingtags.map((intags: PostingTag) => intags.tag.id)

      const managersIds = this.data.manager ? [incomingManager.id] : [];

      const employment_type = [{ id: incomingEmploymentType, name: incomingEmploymentType }];

      const postingPublic = incomingPublic ? PostingPublicValues.MARKETPLACE : PostingPublicValues.INTERNAL;

      const industries = incomingIndustries.map((item: any) => item.industry);

      const durationUnit = incomingDuration % 7 === 0 ? DurationUnit.WEEKS : DurationUnit.DAYS;

      const country = incomingCountry ? [{ id: incomingCountry, name: incomingCountry }] : [];

      const state = incomingState ? [{ id: incomingState, name: incomingState }] : [];

      let duration = 1;

      if (incomingDuration) {
        duration = incomingDuration % 7 === 0 ? incomingDuration / 7 : incomingDuration;
      }

      this.posting = {
        ...this.posting,
        ...this.data,
        public: postingPublic,
        employment_type,
        durationUnit,
        industries,
        duration,
        managersIds,
        skillsIds,
        country,
        state,
        tagsIds: tagIds,
        min_rate,
        max_rate
      };
    }
  }
  updateTags(allChosenTags, newTagsNames: []): void {
    this.posting.tagsIds = allChosenTags
  }
  get managersIds(): string[] {
    return this.posting.managersIds;
  }

  get canEditManager(): boolean {
    return !this.managerId;
  }

  @Watch("countryName", { immediate: false })
  clearCountry(newCountry: string): void {
    if (newCountry !== this.countryFromDB || !Boolean(newCountry)) {
      this.posting.state = [];
      this.posting.city = "";
    }
  }

  get countryName(): string | null {
    if (!this.posting.country?.length) {
      return null;
    }
    return this.posting.country[0].name;
  }

  get stateName(): string | null {
    if (!this.posting.state?.length) {
      return null;
    }
    return this.posting.state[0].name;
  }

  get isCountrySpecified(): boolean {
    return Boolean(this.countryName);
  }

  get isCountryUSA(): boolean {
    return this.countryName === ProfileCountries.USA;
  }

  get stateProvinceSelectTitle(): string {
    return getStateProvinceSelectTitle(this.posting.country || []);
  }

  get modalTitle(): string {
    return `${this.modalPurpose} Posting`;
  }

  get modalPurpose(): string {
    return this.data ? "Edit" : "Create";
  }

  get isEditing(): boolean {
    return this.modalPurpose === "Edit";
  }

  get isContractEmployment(): boolean {
    const type = this.posting.employment_type[0]?.name;
    return type === EmploymentType.CONTRACTOR;
  }

  get isDurationInterval(): boolean {
    return this.posting.duration_type === DurationType.INTERVAL;
  }

  get postingDuration(): number | null {
    if (this.isContractEmployment) {
      if (this.isDurationInterval) {
        const start = this.$moment(this.posting.start_date);
        const end = this.$moment(this.posting.end_date);

        return end.diff(start, "days");
      }

      if (this.posting.durationUnit === DurationUnit.WEEKS) {
        return (this.posting.duration *= 7);
      }
      return this.posting.duration;
    }

    return null;
  }

  get postingEmploymentType(): string {
    return this.posting.employment_type[0].name;
  }

  get postingManager(): string | null {
    return this.posting.managersIds[0] || null;
  }

  get postingPublic(): boolean {
    return PostingPublicValues.MARKETPLACE === this.posting.public;
  }

  get postingForDB(): PostingDTO {
    const manager_id = this.managerId ? this.managerId : this.postingManager;
    const {
      active,
      company_id,
      city,
      description,
      job_title,
      duration_type,
      start_date,
      end_date,
      min_rate,
      max_rate
    } = this.posting;

    return {
      job_title: job_title!,
      country: this.countryName,
      state: this.stateName,
      city: city || null,
      employment_type: this.postingEmploymentType,
      duration: this.postingDuration,
      public: this.postingPublic,
      duration_type,
      description,
      manager_id,
      company_id,
      start_date,
      end_date,
      active,
      max_rate,
      min_rate
    };
  }

  get durationTitle(): string {
    return `Duration (${this.posting.durationUnit})`;
  }

  handleManagerInput(managersIds: string[]): void {
    this.posting = {
      ...this.posting,
      managersIds,
    };
  }

  handleEmploymentTypeInput([employmentType]: DropdownOption[]): void {
    this.posting.employment_type = [employmentType] || undefined;
  }

  closeModal(): void {
    this.$emit("toggle", false);
  }

  submit(): void {
    if (this.data) {
      this.handleUpdate(this.posting);
    } else {
      this.handleCreate(this.posting);
    }
  }

  async handleCreate(posting: PostingFormData): Promise<void> {
    try {
      const newPostingId = await this._createPosting(this.postingForDB);

      if (posting.industries.length) {
        await this._createPostingIndustries(
          posting.industries.map((item: DropdownOption) => {
            return {
              posting_id: newPostingId,
              industry_id: item.id,
            };
          })
        );
      }

      if (posting.skillsIds.length) {
        await this._createPostingSkills(
          posting.skillsIds.map(skillId => {
            return {
              posting_id: newPostingId,
              skill_id: skillId,
            };
          })
        );
      }
      if (posting.tagsIds.length) {
        await this._createPostingTags(
          posting.tagsIds.map((tagId: any) => {
            return {
              posting_id: newPostingId,
              tag_id: tagId?.id as any ? tagId.id : tagId,
            };
          })
        );
      }

      this.$eventBus.emit(NOTIFICATION, Message.successMessage("Posting was created successfully."));
      this.closeModal();
      this.$emit("refecthPosting");
      this.$router.push({ name: RouteNames.RECRUITING_POSTING, params: { id: newPostingId } });
    } catch (e) {
      this.$eventBus.emit(NOTIFICATION, Message.errorMessage(e.message));
    }
  }

  async handleUpdate(posting: PostingFormData): Promise<void> {
    try {
      const postingSkills: PostingSkillData[] = posting.skillsIds.map(skillId => ({
        posting_id: posting.id!,
        skill_id: skillId,
      }));

      const postingIndustries: PostingIndustry[] = posting.industries.map(({ id }) => ({
        posting_id: posting.id!,
        industry_id: id,
      }));
      const postingTags: PostingTagData[] = posting.tagsIds.map((tagId) => ({
        posting_id: posting.id!,
        tag_id: tagId,
      }));

      await this._updatePosting(posting.id!, this.postingForDB, postingSkills, postingIndustries, postingTags);

      this.$eventBus.emit(NOTIFICATION, Message.successMessage("Posting was successfully updated."));
      this.closeModal();
    } catch (e) {
      this.$eventBus.emit(NOTIFICATION, Message.errorMessage(e.message));
    }
  }

  async _createPosting(posting: PostingDTO): Promise<string> {
    const newPosting = await this.$apollo.mutate({
      mutation: CREATE_POSTING,
      variables: { object: posting },
    });

    return newPosting.data.insert_posting_one.id;
  }

  async _updatePosting(
    postingId: string,
    posting: PostingDTO,
    postingSkills: PostingSkillData[],
    postingIndustries: PostingIndustry[],
    postingTags: PostingTagData[]
  ): Promise<void> {
    await this.$apollo.mutate({
      mutation: UPDATE_POSTING,
      variables: {
        id: postingId,
        set: posting,
        industriesSet: postingIndustries,
        skillsSet: postingSkills,
        tagsSet: postingTags
      },
    });
  }

  async _createPostingIndustries(objects: PostingIndustry[]): Promise<void> {
    await this.$apollo.mutate({
      mutation: CREATE_POSTING_INDUSTRIES,
      variables: { objects },
    });
  }

  async _createPostingSkills(objects: PostingSkillData[]): Promise<void> {
    await this.$apollo.mutate({
      mutation: CREATE_POSTING_SKILLS,
      variables: { objects },
    });
  }
  async _createPostingTags(objects: PostingTagData[]): Promise<void> {
    await this.$apollo.mutate({
      mutation: CREATE_POSTING_Tags,
      variables: { objects },
    });
  }
}
